<template>
  <div>
    <Breadcrumbs main="Beacon" title="Group" />

    <div class="container-fluid">
      <div class="d-flex justify-content-end m-3">
        <b-button variant="primary" class="btn-pill" @click="openModal('Add')">
          <i class="icofont icofont-plus-circle"></i> Add New</b-button>
      </div>
      <ValidationObserver v-slot="{ invalid }">
        <b-modal :hide-footer="modalData.title == 'View'" content-class="rounded-1" v-model="show" body-class="p-4"
          centered :title="`${modalData.title} Group`">
          <div class="row">
            <div class="col-12">
              <ValidationProvider name="Group Name" rules="required|customRegex|customRegexCRLF|max_length200"
                v-slot="{ errors }">
                <b-form-group label="Group Name" label-for="name">
                  <template #description>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </template>
                  <b-form-input v-model="name" id="name" :disabled="modalData.disable"></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-12">
              Member
              <vue-select-sides style="height: 30vh" type="mirror" v-model="member" :list="listMember"
                disabled></vue-select-sides>
              <!-- {{ member }} -->
            </div>
          </div>
          <template #modal-footer>
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button variant="primary" :disabled="invalid || member.length == 0" @click="save(modalData)"><i
                class="fa fa-save"></i> Save
            </b-button>
          </template>
        </b-modal>
      </ValidationObserver>

      <div class="card p-4">
        <dataTableVue ref="refDataTable" :isSearch="false" :isFilter="true" :isImport="true" :isExport="true" v-bind:data="{
                  module: 'beacon',
                  columns: columns,
                  rows: rows,
                  importDetail: importDetail,
                  exportDetail: exportDetail,
                  filter_col: [0, 1],
                  filter_custom: 'dynamicFilterVue',
                }" @load="loadItems" @openModal="openModal" @deleteRow="deleteRow" />
      </div>
    </div>
  </div>
</template>

<script>
import { requestService } from './../../_services';

export default {
  data() {
    return {
      list: [],
      enabled: true,
      name: '',
      group: [],
      member: [],
      drag: false,

      copy: [],
      modalData: {
        title: null,
        disable: false,
        row: null,
      },
      show: false,
      columns: [
        {
          label: 'Group Name',
          field: 'name',
          hidden: false,

        },
        {
          label: 'Member',
          field: 'member',
          hidden: false,
        },
        {
          label: 'Update Date',
          field: 'updated_at',
          hidden: false,
        },
        {
          label: 'Action',
          field: 'action',
          thClass: 'custom-th-class',
          hidden: false,
        },
      ],
      rows: [],
      importDetail: {
        importUrl: '/api/group/import/all',
        importField: [
          {
            key: 'name',
            isFind: null,
          },
          {
            key: 'member_name',
            isFind: null,
          },
        ],
      },
      exportDetail: {
        fileName: 'export_group',
        exportUrl: '',
      },
    };
  },
  computed: {
    listMember() {
      return this.group.map(({ name: label, id: value, ...rest }) => ({
        label,
        value,
        disabled: this.modalData.disable,
        ...rest,
      }));
    },
  },
  watch: {
    show(newValue, oldValue) {
      if (oldValue) {
        this.name = '';
        this.member = [];
        this.group = this.copy;
      }
    },
  },
  mounted() {
    // this.loadColumn();
    let url = '/api/member/all';

    setTimeout(() => this.loadItems(), 1000);
    setTimeout(
      () =>
        requestService.GetFetch('beacon', url).then((response) => {
          response.text().then((text) => {
            const data = text && JSON.parse(text);
            data.data.map((item) => {
              this.group.push({
                value: item._id,
                name: `${item.first_name} ${item.last_name}`,
              });
            });
            this.copy = JSON.parse(JSON.stringify(this.group));
            // this.group = data;
          });
        }),
      2000
    );
  },

  methods: {
    deleteRow(value) {
      const url = `/api/group/${value.row._id}`;
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
        })
        .then((result) => {
          if (result.isConfirmed) {
            requestService
              .DeleteFetch('beacon', url)
              .then(() => {
                this.$swal.fire(
                  'Deleted!',
                  'Your file has been deleted.',
                  'success'
                );
                this.loadItems();
              })
              .catch((err) => {
                this.$swal.fire({
                  icon: 'error',
                  title: 'Try Again',
                  text: err,
                });
              });
          }
        });
    },
    save(value) {
      this.show = !this.show;
      const url = `/api/group${value.title.match('Edit') ? '/' + value.row.row._id : ''
        }`;
      const object = {
        name: this.name,
        member: this.member,
      };
      requestService
        .PostFetch('beacon', url, object)
        .then(() => {
          this.$swal.fire({
            icon: 'success',
            title: 'Group has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          this.group = this.copy;
          this.name = '';
          this.member = [];
          this.loadItems();
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
          });
        });
    },
    openModal(value, id) {
      this.modalData.title = value;
      this.modalData.row = id;
      this.show = !this.show;

      if (!value.match('Add')) {
        let url = `/api/group/id/${id.row._id}`;
        this.name = id.row.name;

        requestService.GetFetch('beacon', url).then((response) => {
          response.text().then((text) => {
            const data = text && JSON.parse(text);
            this.member = data.data[0].member.map((item) => item._id);
          });
        });
      }
      value.match('View')
        ? (this.modalData.disable = true)
        : (this.modalData.disable = false);
    },
    async loadItems(event) {
      var str = '';
      if (event != undefined) {
        for (var key in event.params) {
          if (str != '') {
            str += '&';
          }
          str += key + '=' + encodeURIComponent(event.params[key]);
        }
        this.columns.forEach((element) => {
          if (event.sortField == element.field) {
            if (
              event.sortField == 'created_at' ||
              event.sortField == 'updated_at'
            ) {
              str += '&' + 'sortField=' + event.sortField;
            } else {
              str += '&' + 'sortField=' + element.field;
            }
          }
        });
        if (event.filter != undefined) {
          for (var key in event.filter) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.filter[key]);
          }
        }
      }

      var url = '/api/group/filter?' + str;
      this.exportDetail.exportUrl = '/api/group/export?' + str;
      return requestService
        .GetFetch('beacon', url)
        .then((response) => {
          if (response.status == 200) {
            response.text().then((text) => {
              let self = this;
              self.rows = [];
              const data = text && JSON.parse(text);
              if (data.data.data != null) {
                self.json_data = data.data.data;
                self.rows = data.data.data;
                self.$refs.refDataTable.setTotalRecords(data.data.total);
                self.$refs.refDataTable.setPages(data.data.current_page);
              } else {
                self.$refs.refDataTable.setTotalRecords(0);
                self.$refs.refDataTable.setPages(1);
              }
            });
          }
        })
        .catch((error) => {
          this.$notify({ text: error, type: 'danger' });
        });
    },
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}

.list-group-item {
  cursor: move;
}
</style>
